import { Title } from '../atoms/Title';
import { RichText } from '../atoms/RichText';
import { useDOMPurify } from '../../../lib/useDOMPurify';
import useMobileView from '../../../hooks/useMobileView';
import { ImageBlock } from './ImageBlock';

interface FeatureProps {
	imageUrl: string;
	title?: string;
	summary: string;
	maxWidth?: number;
	useImageAsHorizontal: boolean;
}

const textClassNames =
	'flex-1 mx-4 my-3 px-4 py-3 w-auto h-full overflow-y-auto max-h-[95%] scrollbar-thin-hp';
const containerClasses =
	'flex h-[741px] sm:h-[603px] bg-primary-gray rounded-[16px] overflow-hidden';

const generateFlexDirectionClass = (
	useImageAsHorizontal: boolean | null,
	isMobile: boolean,
) => {
	if (!isMobile && !useImageAsHorizontal) return 'flex-row';

	return 'flex-col';
};

const CarouselItem = ({
	summary,
	imageUrl,
	title,
	maxWidth,
	useImageAsHorizontal,
}: FeatureProps) => {
	const sanitizedContent = useDOMPurify(summary);
	const isMobile = useMobileView(640);
	const maxWidthDefaultClass = 'max-w-[80%]';
	const maxWidthClass = maxWidth
		? `max-w-[${maxWidth}px]`
		: maxWidthDefaultClass;
	const figureClasses = `${!isMobile && !useImageAsHorizontal ? 'basis-[50%]' : 'basis-auto'}`;
	const imgClasses = `${isMobile ? 'max-h-[487px]' : 'max-h-auto'} h-auto w-auto ${isMobile ? 'mx-auto' : 'mx-0'}`;
	const flexClasses = generateFlexDirectionClass(
		useImageAsHorizontal,
		isMobile,
	);

	if (!imageUrl) {
		console.error('Missing imageUrl in CarouselItem');
		return null;
	}

	return (
		<div className={`${containerClasses} ${flexClasses} ${maxWidthClass}`}>
			<ImageBlock
				alt={title || ''}
				src={imageUrl}
				classOverrides={imgClasses}
				figureClassOverrides={figureClasses}
			/>
			<div className={textClassNames}>
				{title ? <Title title={title} style="H3" /> : null}
				{summary ? <RichText richText={sanitizedContent} /> : null}
			</div>
		</div>
	);
};

export default CarouselItem;
